<div class="toast-main">
  <div class="color" [ngClass]= "{success: success, warning: warning, error: error}"></div>
  <div class="icon">
    @if (success) {
      <mat-icon class="success">check_circle_24px</mat-icon>
    }
    @if (warning) {
      <mat-icon class="warning">warning_24px</mat-icon>
    }
    @if (error) {
      <mat-icon class="error">error_24px</mat-icon>
    }
  </div>
  <div class="message-box">
    <div class="mat-body-strong message" [ngClass]= "{success: success, warning: warning, error: error}">
      {{ data.message }}
    </div>
    <div class="mat-small">{{ data.description }}</div>
  </div>
  <div class="action">
    <mat-icon (click)="dismiss()">clear_24px</mat-icon>
  </div>
</div>

